module.exports = __webpack_public_path__ + "img/pig-nose.8f7afc46.png";